<div class="container">
  <mat-card appearance="outlined">
    @if (resetPasswordResponse(); as response) {
      @if (response.success) {
        <h2>Check Your Email</h2>
        <p style="margin-top: 0">
          If the email address you provided is associated with an existing
          account, then an email was sent to you with further instructions for
          resetting your password.
        </p>
        <p style="margin-bottom: 0">
          <a routerLink="/sign-in">Return to Sign In</a>
        </p>
      } @else {
        <h2>Uh Oh!</h2>
        <p style="margin-top: 0">
          There was an error sending the password reset email. Please try again
          or contact customer service at (866) 783-5767.
        </p>
        <button mat-flat-button color="primary" (click)="onRetry()">
          Try Again
        </button>
      }
    } @else {
      <h2>Reset Password</h2>
      <p style="margin-top: 0">
        We will email you a link to reset<br />
        your password.
      </p>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field hideRequiredMarker>
          <mat-label>Email</mat-label>
          <input type="email" matInput [formControl]="form.controls.email" />
        </mat-form-field>
        <button mat-flat-button color="primary" [disabled]="!form.valid">
          Reset Password
        </button>
        <p style="margin-bottom: 0">
          <a routerLink="/sign-in">Return to Sign In</a>
        </p>
      </form>
    }

    @if (spinner()) {
      <mat-spinner></mat-spinner>
    }
  </mat-card>
</div>
